/**
 * T113: useGeneratePrompt Hook
 * Mutation hook for generating rendered prompts from templates
 */

import { useMutation } from '@tanstack/react-query'
import { generatePrompt, type GeneratePromptInput } from '@/services/prompts'

interface GeneratePromptParams {
  id: string
  input: GeneratePromptInput
}

export function useGeneratePrompt() {
  return useMutation({
    mutationFn: ({ id, input }: GeneratePromptParams) => generatePrompt(id, input),
  })
}
